/**
 *  @class OutfitCard
 *  A lookbook cell. On click it clones its <template> (the look gallery + the
 *  shoppable product cards) into its section's shared outfit drawer and opens it.
 *
 *  Opening/closing goes through the theme's OverlayManager (app.js), so the
 *  close button, backdrop click and Esc all work, and a quick-view opened from
 *  inside the drawer stacks on top of it.
 */
if (!customElements.get('outfit-card')) {
  class OutfitCard extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.trigger = this.querySelector('.outfit-card__trigger');
      this.template = this.querySelector('template');
      if (!this.trigger || !this.template) return;

      this.trigger.addEventListener('click', this.open.bind(this));
    }

    open(event) {
      if (event) event.preventDefault();

      // Resolve the drawer within this section instance (supports >1 section per page),
      // falling back to the global id.
      const root = this.closest('.shopify-section') || document;
      const drawer = root.querySelector('.outfit-drawer') || document.getElementById('Outfit-Drawer');
      if (!drawer) return;

      const content = drawer.querySelector('.outfit-drawer__content');
      const titleEl = drawer.querySelector('.outfit-drawer__title');
      if (!content) return;

      // Populate the shared drawer with this outfit's content.
      content.innerHTML = '';
      content.appendChild(this.template.content.cloneNode(true));

      const title = this.dataset.title || '';
      if (titleEl) titleEl.textContent = title;
      drawer.setAttribute('aria-label', title || 'Look details');

      // Kick off the lazy images we just inserted (they were inert in the template).
      if (window.lazySizes && lazySizes.loader) {
        content.querySelectorAll('.lazyload').forEach((img) => lazySizes.loader.unveil(img));
      }

      // Reset scroll, then open through the theme's OverlayManager (16.x): it
      // clears `inert`, sets `.active`/`body.open-cc`, traps focus, and lets
      // <side-panel-close>, the backdrop and Esc close the panel again.
      content.scrollTop = 0;
      if (typeof OverlayManager !== 'undefined') {
        OverlayManager.open(drawer);
      } else {
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
        drawer.querySelector('.side-panel-close')?.focus();
      }
    }
  }

  customElements.define('outfit-card', OutfitCard);

}
